import React, { useEffect } from 'react'
import { secondaryButtonIconColour } from 'styles/theme/colours'
import { useLocalStorage } from '@node-space/hooks'
import { Button, Icon } from '@node-space/storybook-components'
import { PathNames } from 'constants/General'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { AmplitudeEvent as Event } from 'utils/amplitude/amplitudeEvents'
import { Amp } from 'utils/tracker'
import GetStartedRow from './GetStartedRow'

interface GetStartedListProps {
  setHideGetStarted: React.Dispatch<unknown>
}

export type ProfileType = {
  twoFactorEnabled: boolean
}

const GetStartedList: React.FC<GetStartedListProps> = ({ setHideGetStarted }) => {
  const { profile } = useProfileContext()
  const [merchantDetailsVisited] = useLocalStorage('merchantDetailsVisited')
  const [apiKeysVisited] = useLocalStorage('apiKeysVisited')
  const [paymentCreateVisited] = useLocalStorage('paymentCreateVisited')
  const [walletCreateVisited] = useLocalStorage('walletCreateVisited')

  useEffect(() => {
    Amp.track(Event.HOMEPAGE_TOTAL_USERS)
  }, [])

  const handleDismiss = () => {
    setHideGetStarted(true)
  }
  const noRowPresent =
    profile?.twoFactorEnabled &&
    merchantDetailsVisited &&
    apiKeysVisited &&
    paymentCreateVisited &&
    walletCreateVisited

  if (noRowPresent) {
    return null
  }

  return (
    <div className="mb-10">
      <div className="flex justify-between">
        <h3 className="text-black mb-3 font-semibold ">Get started</h3>
        <Button onClick={handleDismiss} noStyling>
          Dismiss
        </Button>
      </div>
      <div>
        {!profile.twoFactorEnabled && (
          <GetStartedRow
            messageText="Enable Two Factor Authentication (2FA) to secure your account."
            messageButton="Enable 2FA"
            isRecommended
            redirectUrl={`${PathNames.SETTINGS}${PathNames.MANAGE_USER_PROFILE}`}
            Icon={<Icon name="LockIcon" color={secondaryButtonIconColour} />}
          />
        )}
        {!merchantDetailsVisited && (
          <GetStartedRow
            messageText="Setup your merchant details to start accepting payments from your customers."
            messageButton="Add merchant details"
            redirectUrl={`${PathNames.SETTINGS}${PathNames.MANAGE_MERCHANT_DETAILS}`}
            Icon={<Icon name="MerchantIcon" color={secondaryButtonIconColour} />}
            tracking={() => Amp.track(Event.HOMEPAGE_CLICK_MERCHANT_DETAILS)}
          />
        )}
        {!apiKeysVisited && (
          <GetStartedRow
            messageText="Get your API keys and build your payments integration."
            messageButton="Generate API keys"
            redirectUrl={`${PathNames.SETTINGS}${PathNames.MANAGE_API_KEYS}`}
            Icon={<Icon name="ApiIcon" color={secondaryButtonIconColour} />}
            tracking={() => Amp.track(Event.HOMEPAGE_CLICK_GENERATE_API_KEYS)}
          />
        )}
        {!paymentCreateVisited && (
          <GetStartedRow
            messageText="Create a manual payment to send to a customer."
            messageButton="Create a payment"
            redirectUrl={`${PathNames.PAYMENTS}${PathNames.PAYMENTS_CREATE}`}
            Icon={<Icon name="PaymentIcon" color={secondaryButtonIconColour} />}
            tracking={() => Amp.track(Event.HOMEPAGE_CLICK_GENERATE_API_KEYS)}
          />
        )}
        {!walletCreateVisited && (
          <GetStartedRow
            messageText="Build your portfolio by trading fiat and crypto balances in your wallet."
            messageButton="Add a wallet balance"
            redirectUrl={`${PathNames.WALLETS}${PathNames.WALLET_CREATE}`}
            Icon={<Icon name="WalletIcon" color={secondaryButtonIconColour} />}
            tracking={() => Amp.track(Event.HOMEPAGE_CLICK_VIEW_ALL_WALLETS)}
          />
        )}
      </div>
    </div>
  )
}

export default GetStartedList
